<template>
  <div class="table-settings">
    <div class="table-list-header">
      <div class="text-2xl font-semibold text-vp-base-900">
        Whitelabel configurations
      </div>
      <router-link
        :to="{ name: 'WhitelabelNew' }"
        class="hover:no-underline"
      >
        <div
          class="flex items-center justify-center fixed bottom-16 right-16 w-14 h-14 sm:h-37 sm:w-30 sm:static bg-vp-primary-900 rounded-full sm:rounded-lg"
        >
          <span class="hidden sm:inline-block text-vp-base-100 text-sm font-semibold">Add</span>
          <Plus class="sm:hidden text-vp-base-100 h-6 w-6" />
        </div>
      </router-link>
    </div>

    <div
      v-if="whitelabelLoading"
      class="text-center"
    >
      Loading...
    </div>

    <div
      v-else
      class="table-list"
    >
      <div class="table-list-item">
        <div class="header-name">
          Name
        </div>
        <div class="header-name">
          Domain
        </div>
      </div>
      <router-link
        v-for="whitelabel in whitelabels"
        :key="whitelabel.id"
        :to="{ name: 'WhitelabelEdit', params: { whitelabelId: whitelabel.id } }"
        class="table-list-item table-link"
      >
        <div class="table-cell-content">
          {{ whitelabel.name }}
        </div>
        <div class="table-cell-content">
          {{ whitelabel.domain }}
        </div>
      </router-link>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Plus } from 'mdue';
import { computed } from 'vue';
import { useWhitelabelStore } from '@/stores/whitelabel';

const whitelabelStore = useWhitelabelStore();
whitelabelStore.fetchAllWhitelabels();
const whitelabels = computed(() => whitelabelStore.whitelabels);
const whitelabelLoading = computed(() => whitelabelStore.loading);
</script>
